'use client'

import {RadioCard as ChakraRadioCard, RadioCardRootProps, Text} from '@chakra-ui/react'
import {FieldRequiredIndicator} from '../../components/form/field-required-indicator.js'
import {useFieldContext} from '../../integrations/form/index.js'
import {ErrorMessage} from './error-message.js'
import {FieldRoot} from './field-root.js'

export interface RadioCardItem {
  label: string
  value: string
}

interface Props extends Omit<RadioCardRootProps, 'value' | 'onValueChange'> {
  items: RadioCardItem[]
  label: string
  placeholder?: string
}

export function RadioCard({items, label, required, placeholder, ...props}: Props) {
  const field = useFieldContext<string | null>()

  return (
    <FieldRoot required={required} disabled={props.disabled}>
      <ChakraRadioCard.Root width="100%">
        <ChakraRadioCard.Label fontSize="sm" fontWeight="medium">
          {label} {required && <FieldRequiredIndicator />}
        </ChakraRadioCard.Label>

        {placeholder && !field.state.value && (
          <Text fontSize="sm" color="fg.muted">
            {placeholder}
          </Text>
        )}

        <ChakraRadioCard.Root
          value={field.state.value}
          onValueChange={({value}) => field.handleChange(value)}
          width="100%"
          required={required}
          {...props}
        >
          {items.map(item => (
            <ChakraRadioCard.Item key={item.value} value={item.value}>
              <ChakraRadioCard.ItemHiddenInput />
              <ChakraRadioCard.ItemControl>
                <Text fontWeight="medium" fontSize="sm" px={2} width="100%">
                  {item.label}
                </Text>
                <ChakraRadioCard.ItemIndicator />
              </ChakraRadioCard.ItemControl>
            </ChakraRadioCard.Item>
          ))}
        </ChakraRadioCard.Root>

        <ErrorMessage />
      </ChakraRadioCard.Root>
    </FieldRoot>
  )
}
